import React, { useRef } from 'react';
import { I18n as I } from 'react-redux-i18n';
import { TooltipButton } from 'vdlib';
import { Button, Input, Space, DatePicker } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { formatCurrencyRounded } from 'vdlib';

import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/el';

const dateFormat = 'DD-MM-YYYY';
const sort = (a, b) => (a > b ? 1 : a < b ? -1 : 0);
const sortMoment = (a, b) => (a.isAfter(b) ? 1 : a.isBefore(b) ? -1 : 0);

const textSearch = (
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
  text
) => (
  <div style={{ padding: 8 }}>
    <Input
      placeholder={`Αναζήτηση ${text}`}
      value={selectedKeys[0]}
      onChange={e =>
        console.log('e.target.value', e.target.value) ||
        setSelectedKeys(e.target.value ? [e.target.value] : [])
      }
      onPressEnter={() => {
        confirm();
      }}
      onBlur={() => {
        confirm();
      }}
      style={{ width: 188, marginBottom: 8, display: 'block' }}
    />
    <Space>
      <Button
        type="primary"
        onClick={() => confirm()}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90 }}
      >
        Search
      </Button>
      <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </Space>
  </div>
);

export const getColumns = (isAdmin, updateFees) => {
  return [
    {
      title: I.t('AUCTION'),
      key: 'AuctionID',
      dataIndex: 'AuctionID',
      width: 65,
      align: 'center',
      fixed: 'left',
      sorter: (a, b) => sort(a.AuctionID, b.AuctionID),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) =>
        textSearch(
          selectedKeys,
          setSelectedKeys,
          confirm,
          clearFilters,
          I.t('AUCTION')
        ),
      filterIcon: filtered => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value, record) =>
        record.AuctionID.toString().toLowerCase().includes(value.toLowerCase()),
    },
  ]
    .concat(
      isAdmin
        ? [
            {
              title: I.t('MERCHANT'),
              key: 'Merchant',
              dataIndex: 'Merchant',
              width: 100,
              align: 'center',
              sorter: (a, b) => sort(a.Merchant, b.Merchant),
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) =>
                textSearch(
                  selectedKeys,
                  setSelectedKeys,
                  confirm,
                  clearFilters,
                  I.t('MERCHANT')
                ),
              filterIcon: filtered => (
                <SearchOutlined
                  style={{ color: filtered ? '#1890ff' : undefined }}
                />
              ),
              onFilter: (value, record) =>
                record.Merchant.toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            },
          ]
        : []
    )
    .concat(
      true
        ? [
            {
              title: I.t('FEE'),
              key: 'Amount',
              dataIndex: 'Amount',
              width: 60,
              align: 'center',
              sorter: (a, b) => sort(a.Amount, b.Amount),
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) =>
                textSearch(
                  selectedKeys,
                  setSelectedKeys,
                  confirm,
                  clearFilters,
                  I.t('FEE')
                ),
              filterIcon: filtered => (
                <SearchOutlined
                  style={{ color: filtered ? '#1890ff' : undefined }}
                />
              ),
              onFilter: (value, record) =>
                record.Amount.toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
              render: (text, record, index) =>
                formatCurrencyRounded(record.Amount),
            },
            {
              title: I.t('PAYMENT'),
              key: 'IsPaid',
              dataIndex: 'IsPaid',
              width: 60,
              // sortOrder: 'ascend',
              sorter: (a, b) => sort(a.IsPaid, b.IsPaid),
              align: 'center',
              filters: [
                {
                  text: (
                    <span>
                      Εξοφλημένο
                      <CheckCircleOutlined
                        style={{
                          color: 'green',
                          display: 'inline-flex',
                          marginLeft: 3,
                        }}
                      />
                    </span>
                  ),
                  value: true,
                },
                {
                  text: (
                    <span>
                      Οφειλή
                      <CloseCircleOutlined
                        style={{
                          color: 'red',
                          display: 'inline-flex',
                          marginLeft: 3,
                        }}
                      />
                    </span>
                  ),
                  value: false,
                },
              ],
              onFilter: (value, record) => record.IsPaid === value,
              render: (text, record, index) => (
                <div style={{ textAlign: 'center' }}>
                  {record.IsPaid ? (
                    <span>
                      Εξοφλημένο
                      <CheckCircleOutlined
                        style={{
                          color: 'green',
                          display: 'inline-flex',
                          marginLeft: 3,
                        }}
                      />
                    </span>
                  ) : (
                    <span>
                      Οφειλή
                      <CloseCircleOutlined
                        style={{
                          color: 'red',
                          display: 'inline-flex',
                          marginLeft: 3,
                        }}
                      />
                    </span>
                  )}
                </div>
              ),
            },
            {
              title: I.t('PAYMENT_DATE'),
              key: 'PaymentDate',
              dataIndex: 'PaymentDate',
              width: 90,
              align: 'center',
              sorter: (a, b) => sortMoment(a.PaymentDate, b.PaymentDate),
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) =>
                textSearch(
                  selectedKeys,
                  setSelectedKeys,
                  confirm,
                  clearFilters,
                  I.t('PAYMENT_DATE')
                ),
              filterIcon: filtered => (
                <SearchOutlined
                  style={{ color: filtered ? '#1890ff' : undefined }}
                />
              ),
              onFilter: (value, record) =>
                record.PaymentDate.format(dateFormat)
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
              render: (text, record) => (
                <span>
                  {record.PaymentDate.isValid()
                    ? moment(record.PaymentDate).format(dateFormat).toString()
                    : null}
                </span>
              ),
            },
            {
              title: I.t('END_DATE_AUCTION'),
              key: 'EndDate',
              dataIndex: 'EndDate',
              width: 70,
              align: 'center',
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) =>
                textSearch(
                  selectedKeys,
                  setSelectedKeys,
                  confirm,
                  clearFilters,
                  I.t('END_DATE_AUCTION')
                ),
              filterIcon: filtered => (
                <SearchOutlined
                  style={{ color: filtered ? '#1890ff' : undefined }}
                />
              ),
              onFilter: (value, record) =>
                record.EndDate.toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
              render: (text, record) => (
                <span>
                  {moment(record.EndDate).format(dateFormat).toString()}
                </span>
              ),
            },
            {
              title: I.t('FOLDER_NO'),
              key: 'FolderNumber',
              dataIndex: 'FolderNumber',
              width: 70,
              align: 'center',
              sorter: true,
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) =>
                textSearch(
                  selectedKeys,
                  setSelectedKeys,
                  confirm,
                  clearFilters,
                  I.t('FOLDER_NO')
                ),
              filterIcon: filtered => (
                <SearchOutlined
                  style={{ color: filtered ? '#1890ff' : undefined }}
                />
              ),
              onFilter: (value, record) =>
                record.FolderNumber.toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            },
            {
              title: I.t('PLATE_NUMBER'),
              key: 'PlateNumber',
              dataIndex: 'PlateNumber',
              width: 80,
              align: 'center',
              sorter: true,
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) =>
                textSearch(
                  selectedKeys,
                  setSelectedKeys,
                  confirm,
                  clearFilters,
                  I.t('PLATE_NUMBER')
                ),
              filterIcon: filtered => (
                <SearchOutlined
                  style={{ color: filtered ? '#1890ff' : undefined }}
                />
              ),
              onFilter: (value, record) =>
                record.PlateNumber.toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            },
            {
              title: I.t('BRAND'),
              key: 'VehicleBrand',
              dataIndex: 'VehicleBrand',
              width: 60,
              align: 'center',
              sorter: true,
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) =>
                textSearch(
                  selectedKeys,
                  setSelectedKeys,
                  confirm,
                  clearFilters,
                  I.t('BRAND')
                ),
              filterIcon: filtered => (
                <SearchOutlined
                  style={{ color: filtered ? '#1890ff' : undefined }}
                />
              ),
              onFilter: (value, record) =>
                record.VehicleBrand.toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            },
            // {
            //   title: I.t('MODEL'),
            //   key: 'VehicleModel',
            //   dataIndex: 'VehicleModel',
            //   width: 100,
            //   align: 'center',
            //   sorter: true,
            //   filterDropdown: ({
            //     setSelectedKeys,
            //     selectedKeys,
            //     confirm,
            //     clearFilters,
            //   }) =>
            //     textSearch(
            //       selectedKeys,
            //       setSelectedKeys,
            //       confirm,
            //       clearFilters,
            //       I.t('MODEL')
            //     ),
            //   filterIcon: filtered => (
            //     <SearchOutlined
            //       style={{ color: filtered ? '#1890ff' : undefined }}
            //     />
            //   ),
            //   onFilter: (value, record) =>
            //     record.VehicleModel.toString()
            //       .toLowerCase()
            //       .includes(value.toLowerCase()),
            // },
          ]
        : []
    )
    .concat(
      isAdmin
        ? [
            {
              key: _.uniqueId(),
              width: 30,
              align: 'center',
              fixed: 'right',
              render: (text, record) => (
                <div className="cell-fix-wrap">
                  <TooltipButton
                    onClick={e => updateFees([record.ID], !record.IsPaid)}
                    className={`${
                      record.IsPaid ? 'red' : 'green'
                    } action-button`}
                    icon="euro"
                    text={I.t(record.IsPaid ? 'DEBT' : 'PAYMENT')}
                  />
                </div>
              ),
            },
          ]
        : []
    );
};
// {
//   title: <div style={{ textAlign: 'center' }}>Ασφαλιστική</div>,
//   key: _.uniqueId(),
//   dataIndex: 'InsuranceID',
//   width: 400,
//   align: 'center',
//   render: (text, record, index) => (
//     <div style={{ textAlign: 'center' }}>
//       <div>
//         <span style={{ fontWeight: 600, textAlign: 'center' }}>
//           {LookupsHelper.getDescription(insurances, record.InsuranceID)}
//         </span>
//       </div>
//       <div>
//         <span style={{ fontSize: 12, textAlign: 'center' }}>
//           {record.UserName || record.ExpertUsername}
//         </span>
//       </div>
//     </div>
//   ),
// },
